import React from 'react';

import arrowUpRightIcon from '../brand/icon-arrow-up-right.svg';

import './CarouselArrow.css';

type CarouselArrowProps = {
    direction: 'prev' | 'next';
    ariaLabel: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
    size?: 'default' | 'compact';
    focusColor?: string;
    disabled?: boolean;
};

export function CarouselArrow({
    direction,
    ariaLabel,
    onClick,
    className,
    size = 'default',
    focusColor,
    disabled,
}: CarouselArrowProps) {
    const classes = [
        'carousel-arrow',
        `carousel-arrow--${direction}`,
        `carousel-arrow--${size}`,
        'faves-glass',
        className,
    ].filter(Boolean).join(' ');
    const style = focusColor
        ? ({ '--carousel-arrow-focus': focusColor } as React.CSSProperties)
        : undefined;

    return (
        <button
            type="button"
            className={classes}
            onClick={onClick}
            aria-label={ariaLabel}
            style={style}
            disabled={disabled}
        >
            <img src={arrowUpRightIcon} alt="" className="carousel-arrow__icon" />
        </button>
    );
}
